import { useApi } from '@hero/context';
import type { UseRegionAllCitiesApi, UseRegionCreateApi } from './types';
import { useMutationAPI, useQueryAPI } from '../../utils';

/**
 * Get the full list of platform cities (used by the lane / route pickers).
 * The backend endpoint is `region.getAllCities` — it returns a small fixed
 * list of cities so we cache aggressively via the `region` entity config.
 */
export const useRegionAllCitiesApi: UseRegionAllCitiesApi = apiConfig => {
  const api = useApi();
  return useQueryAPI({
    entity: 'region',
    apiFn: api.common.region.getAllCities,
    query: undefined,
    apiConfig,
  });
};

/**
 * Create (or resolve) a region from a lat/lng pin. Uses useApi() — common
 * method on all SDKs. Idempotent server-side: a point inside an existing
 * region returns that region; brand-new places land as `needs_review` for
 * non-super-admins. Invalidates the `region` entity (cities list, search,
 * translate) so pickers reflect the new region immediately.
 *
 * @see Hook API: {@link UseRegionCreateApi}
 */
export const useRegionCreateApi: UseRegionCreateApi = apiConfig => {
  const api = useApi();
  return useMutationAPI({
    entity: 'region',
    apiFn: api.common.region.create,
    apiConfig,
  });
};
